import styled from 'styled-components';
import IconChevronDown from './IconChevronDown';
var IconChevronLeft = /*#__PURE__*/styled(IconChevronDown).withConfig({
  displayName: "IconChevronLeft",
  componentId: "c11n-8-107-0__sc-ddr5cu-0"
})(["transform:rotate(90deg);"]);
export default IconChevronLeft;